export default __webpack_public_path__ + "static/media/tweet3.e42c046c.png";